<template>
    <div class="our_past_event_wrp">
        <div class="vista_video_wrp">
            <div class="vista_video_body_wrp">
                <h1 class="vista_main_heading">Our Events</h1>
                <p class="vista_main_subheading">Welcome to Lymphomap's Events Page</p>
                <div class="media_video_section">
                    <div class="media_video_slider" v-if="ourEventData">
                        <carousel :mouseDrag="true" :touchDrag="false" :autoplay="false" :loop="false" :nav="false"
                            :margin="15" :dots="false" :items="4"
                            :responsive="{ 0: { items: 1 }, 1024: { items: 4 }, 1900: { items: 6 } }" v-model="ourEventResults"
                            v-once>
                            <template slot="prev"><span class="media_slider_arrow media_slider_prev"><i
                                        class="fa fa-angle-left" aria-hidden="true"></i></span></template>
                            <div v-for="item in ourEventResults" :key="item.id">
                                <div class="video_details">
                                    <router-link :to="{ name: 'eventInfo', params: { evtId: item.id } }">
                                        <div class="video_thumb">
                                            <img :src="item.thumbnail" class="img-fluid">
                                        </div>
                                        <div class="playerinfo">
                                            <h3 class="player_name" :title="item.title">{{ item.title }}
                                            </h3>
                                            <div class="player_designation" v-html="item.description"></div>
                                            <div class="video_uploaded_date"><i class="fa fa-upload mr-1"></i>
                                                {{ item.datetime |
                                                LocalDateFormat}}</div>
                                        </div>
                                    </router-link>
                                </div>
                            </div>
                            <template slot="next"><span class="media_slider_arrow media_slider_next"><i
                                        class="fa fa-angle-right" aria-hidden="true"></i></span></template>
                        </carousel>
                    </div>
                </div>
                <div class="more_video_vista text-center pt-5">
                    <router-link :to="{ name: 'allEventList' }" class="btn btn-primary">More Events</router-link>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
/*eslint-disable */
import carousel from 'vue-owl-carousel'
export default {
    name: 'our-past-event-screen',
    components: {
        carousel
    },
    props: [],
    data() {
        return {
            ourEventData: null,
            ourEventResults: []
        }
    },
    computed: {
    },
    mounted() {
        this.$store.dispatch('eventListAction').then((res) => {
            this.ourEventData = res.data
            this.ourEventResults = this.ourEventData.data
        })
    },
    methods: {
    },
    watch: {
    },
}
</script>

<style lang="scss" scoped>
.our_past_event_wrp {
    min-height: 100dvh;
    padding: 70px 10px 10px;

    .vista_video_wrp {
        color: #ffffff;
        font-family: -apple-system, BlinkMacSystemFont, Segoe UI, Helvetica Neue, Arial, sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol, Noto Color Emoji;
        letter-spacing: 1px;
        background: rgba(0, 0, 0, 0.75);
        min-height: calc(100dvh - 80px);

        .main_heading {
            color: #ffffff;
            font-size: 24px;
            text-transform: uppercase;
            font-weight: bold;
            margin: 0px;
        }

        .vista_video_body_wrp {
            padding: 20px 30px;

            @media only screen and (max-width:767px) {
                padding: 15px;
            }

            a {
                color: inherit;
                text-decoration: none;
            }

            .video_details {
                background: linear-gradient(-30deg, rgba(37, 44, 84, 0.6) 0%, rgba(0, 0, 0, 0.6) 50%, rgba(38, 38, 38, 0.6) 50%, rgba(44, 44, 84, 0.6) 100%);
                border: 1px solid rgba(93, 93, 93, 0.4);
                border-radius: 8px;
                text-align: left;
                transform: scale(1);
                -webkit-transform: scale(1);
                -moz-transform: scale(1);
                transition: all .5s ease;
                -webkit-transition: all .5s ease;
                -moz-transition: all ease .5s;
                transform-origin: center center;
                -webkit-transform-origin: center center;
                -moz-transform-origin: center center;
                &:hover {
                transform: scale(1.01);
                -webkit-transform: scale(1.01);
                -moz-transform: scale(1.01);
                    .player_name{
                        color: #ffd400;
                    }
                }
                a{
                  display: block;
                  padding: 10px;
                }
            }

            .playerinfo {
                margin-top: 8px;
            }

            .media_heading {
                font-size: 24px;
                font-family: 'the_bold_fontbold';
                margin-bottom: 10px;
                line-height: 1;
                color: #fffcc4;

                @media only screen and (max-width:767px) {
                    font-size: 16px;
                }
            }

            .video_thumb {
                height: 200px;
                display: block;
                max-width: 100%;

                .img-fluid {
                    height: 100%;
                    width: 100%;
                    object-fit: cover;
                    object-position: center center;
                }
            }

            .player_name {
                font-size: 18px;
                font-weight: 600;
                line-height: 1.3;
                margin: 0px 0px 5px;
                font-family: "BeonMedium", sans-serif;
                height: 45px;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: normal;
                -webkit-line-clamp: 2;
                line-clamp: 2;
                -webkit-box-orient: vertical;
                display: -webkit-box;
                color: #87cefa;

            }

            .player_designation,
            .player_place {
                font-size: 16px;
                color: #d6d6d6;
                /* text-align: justify; */
                font-family: 'georgiaregular';
                line-height: 1.3;
                margin-bottom: 5px;
                height: 40px;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: normal;
                -webkit-line-clamp: 2;
                -webkit-box-orient: vertical;
                display: -webkit-box;
            }

            .video_uploaded_date,
            .video_views {
                color: #747474;
                font-size: 13px;
                font-family: 'MyriadProRegular', 'Lato', sans-serif;
            }

            .desc_describe_txt {
                display: inline-block;
                margin-left: 10px;
                position: relative;

                .fa {
                    cursor: pointer;
                }

                .fa:hover {
                    color: #87cefa;
                }

                .desc_tooltip_text {
                    left: -325px;
                    position: absolute;
                    background: #fff176;
                    padding: 8px 10px;
                    cursor: default;
                    z-index: 999;
                    font-weight: 600;
                    line-height: 1.3;
                    font-family: -apple-system, BlinkMacSystemFont, Segoe UI, Helvetica Neue, Arial, sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol, Noto Color emoji;
                    font-size: 16px;
                    color: #000;
                    top: 31px;
                    border-radius: 2px;
                    width: 660px;
                    display: none;
                    text-align: justify;
                    letter-spacing: 0px;

                    @media only screen and (max-width:767px) {
                        width: 290px;
                        left: auto;
                        font-size: 14px;
                        top: 24px;
                        right: -25px
                    }

                    &::before {
                        border: solid;
                        border-color: #fff176 transparent;
                        border-width: 12px 12px 0px 0px;
                        top: -6px;
                        content: "";
                        display: block;
                        left: 50%;
                        position: absolute;
                        z-index: 1000;
                        -webkit-transform: rotate(45deg);
                        transform: rotate(45deg);

                        @media only screen and (max-width:767px) {
                            left: auto;
                            right: 25px;
                        }
                    }
                }

                &:hover .desc_tooltip_text {
                    display: block;
                }
            }

            .lbil_launch_info {
                .desc_tooltip_text {
                    left: -275px !important;

                    &:before {
                        left: 42.5% !important;
                    }
                }
            }

            .media_video_slider {
                position: relative;

                .media_slider_arrow {
                    position: absolute;
                    z-index: 100;
                    top: 50%;
                    left: -21px;
                    transform: translateY(-50%);
                    -webkit-transform: translateY(-50%);
                    -moz-transform: translateY(-50%);

                    .fa {
                        cursor: pointer;
                        font-size: 42px;
                        line-height: 28px;
                        color: #ffc107;

                        &:hover {
                            color: #87cefa;
                        }
                    }

                    &.media_slider_next {
                        right: -21px;
                        left: auto;
                    }
                }
            }
        }
    }

    .media_video_section {
        margin-bottom: 30px;

        &:last-child {
            margin-bottom: 0px;
        }
    }

    .pdf_for_conference {
        display: inline-block;
        margin-left: 15px;

        .fa {
            color: #fffcc4;
            cursor: pointer;

            &:hover {
                color: #87cefa;
            }
        }
    }

    .vista_main_heading {
        color: #d29e00;
        font-size: 40px;
        margin-bottom: 5px;
        font-family: 'origin_tech_demoregular';
        line-height: 1;

        @media only screen and (max-width:767px) {
            font-size: 30px;
            line-height: 1.1;
        }
    }

    .vista_main_subheading {
        font-size: 14px;
        text-transform: capitalize;
        font-family: arial;
        color: #bbb;
        margin-bottom: 30px;
        line-height: 1;

        @media only screen and (max-width:767px) {
            margin-bottom: 20px;
            line-height: 1.3;
        }
    }

    .more_video_vista {
        .btn-primary {
            background: none;
            border: 2px solid #ffe400;
            color: #ffe400 !important;
            text-transform: uppercase;
            font-size: 28px;
            padding: 0px 20px;
            line-height: 1;
            height: auto;
            border-radius: 6px;
            -webkit-box-shadow: none !important;
            box-shadow: none !important;
            line-height: 48px;
            font-family: 'ACETONE';

            &:hover {
                background: #ffe400;
                color: #000000 !important;
            }
        }
    }
}

.mobile_view_display {
    display: none !important;
}

@media only screen and (max-width:767px) {
    .mobile_view_display {
        display: block !important;
    }
}

@media only screen and (max-width:1360px) and (min-width:768px) {
    .our_past_event_wrp {
        .vista_main_heading {
            font-size: 32px;
        }

        .media_heading {
            font-size: 20px !important;
        }

        .vista_main_subheading {
            margin-bottom: 25px !important;
        }

        .video_thumb {
            height: 160px !important;
        }

        .player_name {
            font-size: 15px !important;
            height: 40px !important;
        }

        .player_designation {
            height: 35px !important;
            font-size: 14px !important;
        }

        .more_video_vista.pt-5 {
            padding-top: 20px !important;

            .btn-primary {
                font-size: 22px !important;
                line-height: 40px !important;
            }
        }
    }
}

@media only screen and (max-width:1290px) and (min-width:1260px) and (max-height:699px) {
    .our_past_event_wrp {
        .vista_main_heading {
            font-size: 30px;
        }

        .media_heading {
            font-size: 18px !important;
        }

        .vista_main_subheading {
            margin-bottom: 15px !important;
        }

        .video_thumb {
            height: 140px !important;
        }

        .player_name {
            font-size: 14px !important;
            height: 35px !important;
        }

        .player_designation {
            height: 32px !important;
            font-size: 13px !important;
        }

        .more_video_vista.pt-5 {
            padding-top: 20px !important;

            .btn-primary {
                font-size: 22px !important;
                line-height: 40px !important;
            }
        }
    }
}
</style>